module.exports = __webpack_public_path__ + "static/hut-audio-4baa9fd0a19fe7d1f9641fdd1a5f5cfd.mp3";